import { Component, Input, Output, EventEmitter, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { rewriteLocationSegment } from '../../navbar/location-utils';

@Component({
  selector: 'sidebar-nav-link',
  templateUrl: './sidebar-nav-link.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, RouterLink, RouterLinkActive, MatIconModule, MatTooltipModule]
})
export class SidebarNavLinkComponent {
  @Input() link: any;
  @Input() locationNumber: string;
  @Input() variant: string = 'desktop';
  @Input() showLabel: boolean = true;
  @Input() tooltipText: string = '';
  @Input() tooltipPosition: 'left' | 'right' | 'above' | 'below' = 'right';
  @Input() showTooltip: boolean = false;

  @Output() linkClick = new EventEmitter<any>();

  public get cssPrefix(): string {
    return this.variant === 'mobile' ? 'sidebar-mobile-dropdown' : 'sidebar';
  }

  // routerLinkActive compares this target against the router's current (always
  // location-prefixed) URL via exact UrlTree equality, so the link itself must carry
  // the prefix for "active" highlighting to work at all.
  public get resolvedUrl(): string {
    return this.locationNumber ? rewriteLocationSegment(this.link.url, this.locationNumber) : this.link.url;
  }

  public onLinkClick(): void {
    this.linkClick.emit(this.link);
  }
}
